import { render, staticRenderFns } from "./PostcodeCityList.vue?vue&type=template&id=8d70d6d0&scoped=true"
import script from "./PostcodeCityList.vue?vue&type=script&lang=ts"
export * from "./PostcodeCityList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d70d6d0",
  null
  
)

export default component.exports